import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const RecommendationIcon = ({ label = 'Recommendation', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#f4c223" d="m258 114.3-74.6-10.8L150 35.8l-33.4 67.7L42 114.3 96 167l-12.8 74.4 66.8-35.1 66.8 35L204 167l54-52.7z"/><path d="m150 35.8 33.4 67.7 74.6 10.8-54 52.7 12.8 74.3-66.8-35-66.8 35.1L96 167l-54-52.7 74.6-10.8L150 35.8m0-10a10.1 10.1 0 0 0-9 5.6l-31 63-69.5 10a10.3 10.3 0 0 0-8.1 6.8 10.1 10.1 0 0 0 2.6 10.3l50.3 49-11.9 69.2a10 10 0 0 0 4 9.8 10.3 10.3 0 0 0 5.8 1.9 10 10 0 0 0 4.7-1.2l62.1-32.6 62.2 32.6a10.4 10.4 0 0 0 4.6 1.1 9.9 9.9 0 0 0 5.9-1.9 10 10 0 0 0 4-9.8l-11.9-69.1 50.2-49a10.1 10.1 0 0 0 2.6-10.3 10.3 10.3 0 0 0-8.1-6.8l-69.5-10-31-63a10.1 10.1 0 0 0-9-5.6z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

RecommendationIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { RecommendationIcon }
